import React from 'react';
import {DropzoneArea} from 'material-ui-dropzone';
import {Button, Container} from '@material-ui/core';
import {PreviewComponentType} from './types';
import './FileImport.scss';

interface FileImportProviderProps {
    handleClear: () => void;
    handleFileLoad: () => void;
    preview: string;
    className?: string;
    data?: File;
    acceptedFiles: string[];
    previewComponent: PreviewComponentType;
}

export default function FileImportProvider(props: FileImportProviderProps) {
    const {
        handleFileLoad,
        preview,
        handleClear,
        data,
        acceptedFiles,
        previewComponent: PreviewComponent,
        className,
    } = props;

    if (preview) {
        return <PreviewComponent src={preview} data={data} handleDelete={handleClear} />;
    }

    return (
        <Container className={className}>
            <DropzoneArea
                dropzoneText={`Drop your ${className} file here or `}
                acceptedFiles={acceptedFiles}
                onChange={handleFileLoad}
                dropzoneParagraphClass="import__dropzone-title"
                filesLimit={1}
                showAlerts={false}
                showPreviews={false}
                showPreviewsInDropzone={false}
                showFileNamesInPreview={false}
                // @ts-ignore
                Icon={UploadButton}
            />
        </Container>
    );
}

export const UploadButton = () => (
    <Button variant="outlined" color="primary">
        BROWSE
    </Button>
);
